import { apiClient } from '../../api/client';

interface UserData {
  [key: string]: any;
}

async function createUser(data: UserData): Promise<any> {
  const requestData = {
    email: data.email,
    password: data.password,
    first_name: data.first_name,
    native_language_iso639: data.native_language_iso639,
    target_language_iso639: data.target_language_iso639,
    preferred_explanation_language_iso639: data.preferred_explanation_language_iso639,
  };
  return apiClient.users.usersCreateUserCreate(requestData);
}

export { createUser };

